import { useState, useEffect } from 'react';
import { addCallback, removeCallback, observer } from 'utils/resizeObserver';

export default (breakpoint = 1024) => {
  const [enhanced, setEnhanced] = useState(window.innerWidth >= breakpoint);

  useEffect(() => {
    const cb = addCallback(function({ width }) {
      setEnhanced(width >= breakpoint);
    });

    return function cleanup() {
      removeCallback(cb);
    };
  }, [breakpoint]);

  useEffect(() => {
    if (observer) {
      observer.observe(document.body);
    }
    return function cleanup() {
      if (observer) {
        observer.unobserve(document.body);
      }
    };
  }, [observer]);

  return enhanced;
};
